import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { ImmediateStateMatcher } from '@common';
import { VouchersStore } from '@store';
import { ValidateVoucherFormGroup } from './validate-voucher.helper';

@Component({
  selector: 'app-validate-voucher',
  templateUrl: './validate-voucher.component.html',
  styleUrls: ['./validate-voucher.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ValidateVoucherComponent {
  formGroup: FormGroup<ValidateVoucherFormGroup> = new FormGroup<ValidateVoucherFormGroup>({
    voucher: new FormControl<string | null>(null, [Validators.required]),
  });

  matcher = new ImmediateStateMatcher();

  constructor(public vouchersStore: VouchersStore) {}

  validateVoucher(): void {
    this.vouchersStore.validateSrcLiteVoucher(this.formGroup.controls.voucher.value);
  }

  checkForEmptyInput(): void {
    const isEmpty = !this.formGroup.controls.voucher.value;

    if (isEmpty) {
      this.formGroup.controls.voucher.setErrors(null);
    }
  }
}
